/**
 * The two marks f8's memory states are read by (PPL-350).
 *
 * Hand-drawn rather than react-feather: feather has no sparkle, and its `Moon`
 * carries a night-mode meaning this app already uses. Both mirror the app's
 * `SparkleGlyph` / `MoonGlyph` so the same person reads the same in both clients.
 *
 * The moon is deliberately not a lock or a slash. f8 has not lost anything about
 * a paused person and is not refusing access to them — it has simply paused.
 * A padlock would say the opposite of what the tier promises.
 */

import React from 'react';

export function Sparkle({ size = 14, color = '#f0abfc' }: { size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Z" fill={color} />
      <path d="M18.5 15l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8.8-2.2Z" fill={color} opacity={0.75} />
    </svg>
  );
}

export function Moon({ size = 14, color = '#fcd34d' }: { size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArchiveGlyph({ size = 15, color = 'rgba(220,200,240,0.5)' }: { size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true"
      stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 8v13H3V8" />
      <rect x={1} y={3} width={22} height={5} />
      <path d="M10 12h4" />
    </svg>
  );
}
